import Home from './views/Home.affise_vars'
import Var from './views/Var.affise_vars'

export default {
  Home, Var
}
